import { Typography, Button } from '@mui/material';
import {
  Datagrid,
  DateField,
  ListContextProvider,
  ResourceContextProvider,
  TextField,
  useGetMany,
  useGetManyReference,
  useList,
  useRecordContext,
  useTranslate,
} from 'react-admin';
import { QuickbooksPriceField } from '../components/QuickbooksPriceField';
import { Contract } from '../types';
import { Divider, Box } from '@mui/material';
import LinkToQbButton from './LinkToQbButton';
import CreditMemoPrintButton from './CreditMemoPrintButton';

const ContractLinkedCreditMemosList = () => {
  const translate = useTranslate();
  const record = useRecordContext<Contract>();

  const { data: supabaseCreditMemos } = useGetManyReference(
    'sb_creditmemos',
    { target: 'contract_id', id: record?.id },
    { enabled: !!record }
  );

  const { data: qbCreditMemosData, isLoading: isCreditMemosLoading } = useGetMany(
    'creditmemos',
    {
      ids: supabaseCreditMemos
        ? supabaseCreditMemos.map((creditmemo) => creditmemo.accounting_reference_id)
        : [],
    },
    { enabled: supabaseCreditMemos && supabaseCreditMemos.length > 0 }
  );
  const creditmemos = qbCreditMemosData ? qbCreditMemosData : [];

  const listContext = useList({ data: creditmemos });


  if (isCreditMemosLoading) return null;
  return (
    <>
    <Box my={4}>
      <Typography variant='h6'>
        {translate('resources.creditmemos.name', { smart_count: creditmemos.length })}
        {/* <CreditMemoButton label="Add Credit Memo" contract_id={record.id} /> */}
      </Typography>
      <Divider />
      <ResourceContextProvider value="creditmemos">
        <ListContextProvider value={listContext}>
          <Datagrid bulkActionButtons={false} rowClick={false}>
            <TextField source="id" />
            <DateField source="TxnDate" />
            <QuickbooksPriceField source="TotalAmt" />
            <CreditMemoPrintButton source="id" label="Print" />
            {/* <TextField source="PrintStatus" /> */}
            {/* <TextField source="EmailStatus" /> */}
          </Datagrid>
        </ListContextProvider>
      </ResourceContextProvider>
    
    </Box>
    </>
  );
};

export default ContractLinkedCreditMemosList;
